// CYBER-ATOMIC
const Modal = () => import(/* webpackChunkName: "Modal" */'./Modal')

export {
  Modal
}
